import { render, staticRenderFns } from "./TiposGastoView.vue?vue&type=template&id=b0fe6966&"
import script from "./TiposGastoView.vue?vue&type=script&lang=js&"
export * from "./TiposGastoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports